/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import e from"../../../request.js";async function r(r,t){let n=null;const a="string"==typeof t?t:t.path;if(!r.has(a)){const s=await e(a.replace(/\/VersionManagementServer/i,"/FeatureServer"),{query:{f:"json"}});n={serverVersion:Number(s.data.currentVersion),featureServerUrl:a.replace(/\/VersionManagementServer/i,"/FeatureServer")},r.set(t,n)}}export{r as addServerVersion};
